import React, { useEffect, useState } from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import styled from 'styled-components';
import { PageContainer, Spacer, TableSkeleton, TitleWithBack } from 'src/common';
import GenericTable, { TableSheetControlLibrary, useControlLibraryColumns } from 'src/components/GenericTable';
import Button from 'src/components/form/Button';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { TableIds } from 'src/api/types/misc';
import { useControlFrameworkDetailsQuery } from 'src/graphql/_generated';
import _ from 'lodash';
import { isQueryLoading } from 'src/graphql/client';
import { showSuccessToast, toastMessages } from 'src/components/Toast';

const Div = styled(PageContainer)`
  .btn-container {
    display: flex;
    justify-content: flex-end;
  }
  .error {
    color: ${({ theme }) => theme.colors.error};
    font-size: 14px;
  }
  .success {
    color: ${({ theme }) => theme.colors.success};
    font-size: 14px;
  }
`;

const ControlsLibrariesPage = () => {
  const [isNewSelection, setIsNewSelection] = useState(true);
  useGaEventPageView('Cydea | Controls Library');

  const { data, loading, networkStatus } = useControlFrameworkDetailsQuery();
  const isLoading = isQueryLoading({ loading, data, networkStatus });
  const controlLibs = _(data?.controlFrameworks).flatMap('frameworkControls').orderBy(['control_identifier']).value();

  const { columns, GTColumnSelectAnchorExported, checked, setChecked, addToRmp, isAddLoading } = useControlLibraryColumns({
    data: controlLibs,
    isCheckerEnabled: true,
    tdm: {
      onAddToRMPClick: true,
    },
    opensSameTab: true,
    tableId: TableIds.controlLib,
  });

  useEffect(() => {
    if (checked.length) {
      setIsNewSelection(true);
    }
  }, [checked]);

  return (
    <>
      <Meta title={`Cydea | Controls Library`} feedbackScript />
      <Div>
        <TitleWithBack title="All Controls" />
        <Spacer $px={30} />
        <div className="btn-container">
          <Button
            primary
            disabled={!checked.length || isAddLoading}
            loading={isAddLoading}
            onClick={() => {
              addToRmp(checked).then(() => {
                setChecked([]);
                setIsNewSelection(false);
              });
              mpEvent(MPEvents.ButtonClick, {
                button: 'Add to RMP',
                tags: ['RMP'],
              });
            }}
            $constWidth={190}
          >
            {isNewSelection ? '+ ADD TO RMP' : 'ADDED TO RMP'}
          </Button>
        </div>
        <Spacer $px={30} />
        {!isLoading ? (
          <>
            <GenericTable
              tableId={TableIds.controlLib}
              data={controlLibs}
              columns={columns}
              GTColumnSelectAnchorExported={GTColumnSelectAnchorExported}
              expandContent={(row) => <TableSheetControlLibrary data={row} />}
              searchable={['framework_controls', 'framework_control_id', 'name', 'FrameworkAuthor']}
            />
          </>
        ) : (
          <TableSkeleton />
        )}
      </Div>
    </>
  );
};

export default ControlsLibrariesPage;
